export const compareModelId = (row, compareModel, column) => {
  // console.log('compareModelId row', row, 'compareModel', compareModel, 'column', column)
  if (column) {
    const {field} = column
    if (field && compareModel && compareModel[field] && compareModel[field].id) {
      // console.log('compareModelId compareModel[field].id', compareModel[field].id)
      return compareModel[field].id
    }
  }
  return 0
}

export const compareData = (row, compareModel, column, value = false) => {
  // console.log('compareData row', row, 'compareModel', compareModel, 'column', column, 'value', value)
  if (column) {
    // console.log('compareData column', column)
    const {field} = column
    // const {field, relation, type, defaultValue} = column
    if (field) {
      let oldValue = compareModel[field]
      let newValue = row[field]
      let oldValueDisplay = oldValue
      let newValueDisplay = newValue
      // console.log('oldValue', oldValue)
      // console.log('newValue', newValue)
      if (typeof oldValue === 'undefined' && typeof newValue !== 'undefined') {
        oldValueDisplay = 'None'
        if (typeof newValue === 'number') {
          oldValue = null
        } else if (typeof newValue === 'string') {
          oldValue = ''
        } else if (typeof newValue === 'boolean') {
          oldValue = false
          oldValueDisplay = 'false'
        } else if (typeof newValue === 'object') {
          oldValue = {}
        } else {
          oldValue = []
        }
      } else if (typeof oldValue !== 'undefined' && typeof newValue === 'undefined') {
        newValueDisplay = 'None'
        if (typeof oldValue === 'number') {
          newValue = null
        } else if (typeof oldValue === 'string') {
          newValue = ''
        } else if (typeof oldValue === 'boolean') {
          newValue = false
          oldValueDisplay = 'true'
        } else if (typeof oldValue === 'object') {
          newValue = {}
        } else {
          newValue = []
        }
      }
      if (!oldValue) {
        oldValueDisplay = 'None'
      }
      if (!newValue) {
        newValueDisplay = 'None'
      }
      if ((oldValue === '' && newValue === '') || (!oldValue && !newValue) || (typeof oldValue === 'undefined' && typeof newValue === 'undefined')) {
        if (value) {
          return ``
        }
        return false
      } else if (typeof oldValue !== 'undefined' && typeof newValue !== 'undefined' && oldValue && newValue) {
        if (typeof oldValue === 'object' && typeof newValue === 'object') {
          if (isEmptyObject(oldValue) && isEmptyObject(newValue)) {
            if (value) {
              return ``
            }
            return false
          } else {
            // Compare Objects
            if (!isEqual(oldValue, newValue)) {
              if (value) {
                return `New value is different, please review`
              }
              return true
            } else {
              if (value) {
                return ``
              }
              return false
            }
          }
        } else if (oldValue.constructor === Array && newValue.constructor === Array) {
          if (isArrayEmpty(oldValue) && isArrayEmpty(newValue)) {
            if (value) {
              return ``
            }
            return false
          } else {
            // Compare arrays
            if (!isEqual(oldValue, newValue)) {
              if (value) {
                return `New value is different, please review`
              }
              return true
            } else {
              if (value) {
                return ``
              }
              return false
            }
          }
        } else if (oldValue !== newValue) {
          if (value) {
            // return `Previous Value: ${oldValueDisplay} & New Value: ${newValueDisplay}`
            return `Previous Value: ${oldValueDisplay}`
          }
          return true
        }
      } else if (oldValue !== newValue) {
        if (value) {
          // return `Previous Value: ${oldValueDisplay} & New Value: ${newValueDisplay}`
          return `Previous Value: ${oldValueDisplay}`
        }
        return true
      }
    }
  }
  if (value) {
    return ``
  }
  return false
}

export const isEmptyObject = (obj) => {
  return Object.entries(obj).length === 0 && obj.constructor === Object
}

export const isArrayEmpty = (array) => {
  if (array && array.length) {
    return false
  }
  return true
}

export const isEqual = (value, other, key = null) => {
  // Get the value type
  // console.log('isEqual', 'key', key)
  let type = Object.prototype.toString.call(value)
  const ignoreArray = ['id', 'updatedAt', 'createdAt', 'approved', 'dateApproved', 'removalDate', 'isNew', 'companyId', 'addressId', 'personId']

  if (key && ignoreArray.indexOf(key) >= 0) {
    // console.log('ignore 2', key)
    return true
  }

  // If the two objects are not the same type, return false
  if (type !== Object.prototype.toString.call(other)) return false

  // If items are not an object or array, return false
  if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false

  // Compare the length of the length of the two items
  let valueLen = type === '[object Array]' ? value.length : Object.keys(value).length
  let otherLen = type === '[object Array]' ? other.length : Object.keys(other).length
  if (valueLen !== otherLen) return false

  // Compare two items
  let compare = function (item1, item2, key = null) {
    // console.log('isEqual compare', item1, item2, 'key', key)
    // console.log('isEqual compare key 1', key)
    if (key && ignoreArray.indexOf(key) >= 0) {
      // console.log('ignore 1', key, ignoreArray.indexOf(key))
      return true
    }
    // console.log('isEqual compare key 2', key)
    // Get the object type
    let itemType = Object.prototype.toString.call(item1)

    // If an object or array, compare recursively
    if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2, key)) {
        return false
      }
    } else {
      // Otherwise, do a simple comparison
      // If the two items are not the same type, return false
      if (itemType !== Object.prototype.toString.call(item2)) return false

      // Else if it's a function, convert to a string and compare
      // Otherwise, just compare
      if (itemType === '[object Function]') {
        if (item1.toString() !== item2.toString()) return false
      } else {
        if (item1 !== item2) return false
      }
    }
  }
  // console.log('compare', compare)

  // Compare properties
  if (type === '[object Array]') {
    for (let i = 0; i < valueLen; i++) {
      // console.log('value[i]', value[i], 'other[i]', other[i], 'i', i)
      if (compare(value[i], other[i]) === false) return false
    }
  } else {
    for (let key in value) {
      if (value.hasOwnProperty(key)) {
        // console.log('value[key]', value[key], 'other[key]', other[key], key)
        if (compare(value[key], other[key], key) === false) return false
      }
    }
  }

  // If nothing failed, return true
  return true
}
